import {emailValidation} from 'validation/email';
import * as Yup from 'yup';

export const addEmailValidation = Yup.object({
  email: emailValidation.required('Please enter an email address'),
});
